<template>
  <div class="utilities-wrapper" v-if="isUtilitiesIncludedInRent">
    <Text variant="body-large" v-for="[key, value] in includedUtilities" :key="key">
      {{ value }}
    </Text>
  </div>
  <p v-else>Not included in rent</p>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Text } from '@tallo/design-system';

import { includedUtilitiesMap } from '../../model/included-utilities';
import { PropertyDto } from '../../model/property';

const props = defineProps<{
  property: PropertyDto | null | undefined;
}>();

const includedUtilities = computed(() => {
  return Array.from(includedUtilitiesMap).filter(([key]) => props.property?.includedUtilities?.[key]);
});
const isUtilitiesIncludedInRent = computed(() => {
  return props.property?.includedUtilities?.isUtilitiesIncludedInRent && Boolean(includedUtilities.value.length);
});
</script>

<style scoped lang="scss">
.utilities-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: var(--t-spacing-sm);
}
</style>
